var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.options.xaxis.categories.length != 0)?_c('div',{staticClass:"ma-1"},[_c('VueApexCharts',{attrs:{"height":"320px","type":"line","options":_vm.options,"series":_vm.series}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }